import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { required, email, max } from 'vee-validate/dist/rules';

export default {
  setup: function (vueInstance) {
    extend('required', {
      ...required,
      message: '{_field_} can not be empty'
    });

    extend('max', {
      ...max,
      message: '{_field_} has too many characters'
    });

    extend('email', {
      ...email,
      message: 'Email must be valid'
    });

    extend('date', value => {
      // First check for the pattern
      if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) {
        return false;
      }

      // Parse the date parts to integers
      const parts = value.split('/');
      const day = parseInt(parts[1], 10);
      const month = parseInt(parts[0], 10);
      const year = parseInt(parts[2], 10);

      // Check the ranges of month and year
      if (year < 1000 || year > 3000 || month === 0 || month > 12) {
        return false;
      }

      const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      // Adjust for leap years
      if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) { monthLength[1] = 29; }

      // Check the range of the day
      return day > 0 && day <= monthLength[month - 1];
    });

    extend('time', value => {
      const validTimeRegex = /((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))/g;
      return !!value.match(validTimeRegex);
    });

    vueInstance.component('ValidationObserver', ValidationObserver);
    vueInstance.component('ValidationProvider', ValidationProvider);
  }
};
